import { graphql } from "@/graphql/generated/gql";
import { MunicipalPropertyUsageListQuery, MunicipalPropertyUsageListQueryVariables } from "@/graphql/generated/graphql";
import { TypedDocumentNode } from "@graphql-typed-document-node/core";

export const MUNICIPAL_PROPERTY_USAGE_LIST_QUERY_DOCUMENT: TypedDocumentNode<
  MunicipalPropertyUsageListQuery,
  MunicipalPropertyUsageListQueryVariables
> = graphql(/* GraphQL */ `
  query MunicipalPropertyUsageList($id: ID!, $first: Int, $after: String) {
    municipalPropertyUsageList(id: $id, first: $first, after: $after) {
      nodeList {
        registerId
        year
      }
      endCursor
      hasNextPage
    }
  }
`);
